import React from 'react';
import  {IndexLink, Link, withRouter} from 'react-router';


class MenuComponent extends React.Component{
    constructor(props) {
        super(props);

        this.state = {
            menuShow: false,
        }
    }

    mouseClick(event) {
        this.setState({menuShow: !this.state.menuShow})
    }

    mouseOut(event) {
        this.setState({menuShow: false})
    }

    mouseLinkClick(link, event) {
        this.props.router.push(link);
    }

    render() {
        return (
            <div className={"mobile-dropdown"}>
                <svg onClick={() => this.mouseClick()} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="30" height="30" focusable="false"><title>Menu</title><path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeMiterlimit="10" d="M4 7h22M4 15h22M4 23h22"></path></svg>
                <ul onMouseOut={() => this.mouseOut()} onMouseLeave={() => this.mouseOut()}  className={this.state.menuShow?"mobile-menu":"hide-el mobile-menu"}>
                    <li onClick={() => this.mouseLinkClick("/business")}><span>Business Solutions</span>{this.props.is_hide==1?"":<img src="/static/img/appimg/menu_icon1.png"/>}</li>
                    <li onClick={() => this.mouseLinkClick("/talent")}><span>Talent Solutions</span>{this.props.is_hide==2?"":<img src="/static/img/appimg/menu_icon1.png"/>}</li>
                    <li onClick={() => this.mouseLinkClick("/advertise")}><span>Advertising Solutions</span>{this.props.is_hide==4?"":<img src="/static/img/appimg/menu_icon1.png"/>}</li>
                    <li onClick={() => this.mouseLinkClick("/talent/contact-us")}><span>Schedule Demo</span>{this.props.is_hide==3?"":<img src="/static/img/appimg/menu_icon1.png"/>}</li>
                    <li onClick={() => this.mouseLinkClick("/employers/signup")}><a className={"btn_v btn_cancel apply3"}>Get Started</a></li>
                </ul>
            </div>
        )
    }
}
MenuComponent.propTypes = {
    router: React.PropTypes.shape({
        push: React.PropTypes.func.isRequired
    }).isRequired
};

export default (withRouter(MenuComponent));



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/commons/menu.js
 **/